import * as React from "react";
import { cn } from "@/utils/cn";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, icon, rightIcon, ...props }, ref) => {
    const hasLeftIcon = !!icon;
    const hasRightIcon = !!rightIcon;

    return (
      <div className="relative w-full">
        {hasLeftIcon && (
          <span
            className={cn(
              "absolute inset-y-0 left-3 flex items-center text-[#7b2a40] opacity-80",
              "pointer-events-none"
            )}
          >
            {icon}
          </span>
        )}

        <input
          type={type}
          ref={ref}
          {...props}
          className={cn(
            "block w-full rounded-md border border-gray-300 bg-white text-sm text-gray-900",
            "placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#7b2a40]/40 focus:border-[#7b2a40]",
            "disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-150 ease-in-out",
            hasLeftIcon ? "pl-9" : "pl-3",
            hasRightIcon ? "pr-9" : "pr-3",
            "py-2.5",
            className
          )}
        />

        {hasRightIcon && (
          <span
            className={cn(
              "absolute inset-y-0 right-3 flex items-center text-[#7b2a40] opacity-80",
              typeof rightIcon === "string" ? "pointer-events-none" : ""
            )}
          >
            {rightIcon}
          </span>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
